import {
    DownloadIcon,
} from '@radix-ui/react-icons';
import { useState } from 'react';
import { CSVLink } from 'react-csv';
import { useForm } from 'react-hook-form';
import { DatePickerWithRange } from '../daterangeWithpicker';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import { DropdownMenuItem } from '../ui/dropdown-menu';

function ExportMembersDialog({clubId, members }) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState();
    const form = useForm();

    // Calculate default dates
    const today = new Date();
    const yearAgo = new Date();
    yearAgo.setFullYear(today.getFullYear() - 1);
    const [selectedDates, setSelectedDates] = useState({ from: yearAgo, to: today });

    const [filteredData, setFilteredData] = useState([]);

    const convertToUTC = (date) => {
        return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0];
    };

    const filterDataByDateRange = (data, fromDate, toDate) => {
        const from = new Date(fromDate);
        const to = new Date(toDate);

        return data.filter((member) => {
            // Always include minimembers regardless of membership dates
            const isMinimember = member.minimember;
            if (isMinimember) return true;

            // If membership_expiration is null, assume member is always active
            if (member.membership_expiration == null) {
                return true;
            }

            const membershipStart = member.membership_started ? new Date(member.membership_started) : new Date(0); // Active from the beginning if null
            const membershipEnd = new Date(member.membership_expiration);

            // Check if the membership period overlaps with the selected date range
            return (membershipStart <= to && membershipEnd >= from);
        });
    };

    const handleDownloadClick = () => {
        if (selectedDates.from && selectedDates.to) {
            const fromDate = convertToUTC(selectedDates.from);
            const toDate = convertToUTC(selectedDates.to);
            const filtered = filterDataByDateRange(members, fromDate, toDate);
            if (JSON.stringify(filtered) !== JSON.stringify(filteredData)) {
                setFilteredData(filtered);
            }
        } else {
            setFilteredData(members);
        }
    };

    return (
        <Dialog modal={true}>
            <DropdownMenuItem onSelect={(event) => event.preventDefault()}>
                <DialogTrigger className='flex items-center w-full text-left'>
                    <DownloadIcon className='mr-3'/>
                    Exportera medlemsdata
                </DialogTrigger>
                <DialogContent className="flex flex-col gap-6" onOpenAutoFocus={(e) => e.preventDefault()}>
                    <DialogHeader className='text-left'>
                        <DialogTitle>Exportera medlemsdata</DialogTitle>
                        <DialogDescription>Ange datumintervall för export av medlemmar. Exporten tar med samtliga användare som har ett aktivt medlemskap i intervallet.</DialogDescription>
                    </DialogHeader>
                    <DatePickerWithRange
                        className='w-full'
                        disabled={isLoading}
                        id='exportDates'
                        defaultDate={{ to: today, from: yearAgo }}
                        onDateChange={(range) => setSelectedDates(range)}
                    />
                    <div className='grid grid-cols-2 gap-3'>
                        <DialogClose asChild>
                            <Button type='button' variant='secondary'>Avbryt</Button>
                        </DialogClose>
                        <Button className="w-full" onClick={handleDownloadClick} disabled={isLoading || !selectedDates.from || !selectedDates.to}>
                            <CSVLink filename={`members_${clubId}.csv`} data={filteredData} className="flex items-center justify-center w-full min-w-36">
                                <DownloadIcon className='mr-3' />
                                Ladda ner
                            </CSVLink>
                        </Button>
                    </div>
                </DialogContent>
            </DropdownMenuItem>
        </Dialog>
    );
};

export default ExportMembersDialog;
